import React from 'react'
import "../styles/OurManufacturing.css";

const OurManuFacturing = () => {
    return (
        <div>
            <div className='manu1'>
                <h3 className="our">Our Components</h3>
                <div className='manu-img1'>
                    <div className="content1" id='autoshow'>
                        <div className="img12"></div>
                    </div>
                    <div className="content1" id='autoshow'>
                        <div className="img13"></div>
                    </div>
                    <div className="content1" id='autoshow'>
                        <div className="img14"></div>
                    </div>
                    <div className="content1" id='autoshow'>
                        <div className="img15"></div>
                    </div>
                    <div className="content1" id='autoshow'>
                        <div className="img16"></div>
                    </div>
                    <div className="content1" id='autoshow'>
                        <div className="img17"></div>
                    </div>
                </div>
            </div>
            <div className='manu'>
                <h3 className="our">Our Own ManuFacturing Products</h3>
                <div className='manu-img'>
                    <div className="content" id='autoshow'>
                        <div className="img4"></div>
                        <h2 className="txt1">Ribbon Blender</h2>
                    </div>
                    <div className="content" id='autoshow'>
                        <div className="img5"></div>
                        <h2 className="txt1">Poultry Feed Mill</h2>
                    </div>
                    <div className="content" id='autoshow'>
                        <div className="img7"></div>
                        <h2 className="txt1">Elevator Feeder</h2>
                    </div>
                    <div className="content" id='autoshow'>
                        <div className="img8"></div>
                        <h2 className="txt1">Feed Chutes</h2>
                    </div>
                    <div className="content" id='autoshow'>
                        <div className="img9"></div>
                        <h2 className="txt1">Hammer Mill Machine</h2>
                    </div>
                    <div className="content" id='autoshow'>
                        <div className="img10"></div>
                        <h2 className="txt1">Ribbon Type Mixer</h2>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default OurManuFacturing
